/** One day of the inbox gap check (GET /email/inbox/gaps): Gmail ids matching the sync's query vs emails stored. */
export type GapRow = { day: string; inGmail: number; stored: number; missing: number };
export type GapReport = {
  from: string;
  to: string;
  rows: GapRow[];
  totals: { inGmail: number; stored: number; missing: number };
};

const GAP_MIN_MISSING = 5;
const GAP_MIN_SHARE = 0.1;
const DAY_MS = 24 * 60 * 60 * 1000;

/**
 * A day worth syncing again: more than 5 missing AND more than 10% of what Gmail holds.
 * Small differences are expected (the sync drops emails with no PDF/Word file), so they are not flagged.
 */
export function isGapDay(row: GapRow): boolean {
  return row.missing > GAP_MIN_MISSING && row.missing > row.inGmail * GAP_MIN_SHARE;
}

/** First to last gap day (inclusive), for "Sync gap days"; null when there are none. */
export function gapSpan(rows: GapRow[]): { from: string; to: string } | null {
  const days = rows.filter(isGapDay).map((r) => r.day).sort();
  if (days.length === 0) return null;
  return { from: days[0], to: days[days.length - 1] };
}

/** The last 14 UTC days, today included. */
export function defaultGapRange(now: Date): { from: string; to: string } {
  const iso = (d: Date) => d.toISOString().slice(0, 10);
  return { from: iso(new Date(now.getTime() - 13 * DAY_MS)), to: iso(now) };
}
